import { createLogger, LogLevel } from '../../../../pages/catalog/assets/js/utils/logger';

const logger = createLogger('CoursesModalEvents', LogLevel.INFO);

export function initCoursesModalEvents(modal: HTMLElement): void {
  // Закрытие по кнопке (svg)
  const closeBtn = modal.querySelector('.close__modal');
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      logger.info('Закрытие модалки по кнопке');
      closeModal(modal);
    });
  }

  // Закрытие по клику вне модального окна
  modal.addEventListener('mousedown', (e) => {
    if (e.target === modal) {
      logger.info('Закрытие модалки по клику вне окна');
      closeModal(modal);
    }
  });

  // Закрытие по ESC
  const escHandler = (e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      logger.info('Закрытие модалки по ESC');
      closeModal(modal);
    }
  };
  document.addEventListener('keydown', escHandler);

  // Удаляем обработчик при закрытии
  function closeModal(modalEl: HTMLElement) {
    logger.info('Модалка закрыта, удаляем обработчики');
    document.removeEventListener('keydown', escHandler);
    // Удаляем .modal только если это модалка курсов
    if (modalEl.classList.contains('modal') && modalEl.classList.contains('course-modal')) {
      modalEl.remove();
      logger.info('Блок .modal.course-modal удалён из DOM');
    } else {
      // fallback: просто скрыть
      modalEl.classList.remove('open', 'course-modal');
    }
  }
} 